import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import AppPageTemplate from '@/components/templates/AppPageTemplate';
import { useAppStore } from '@/store/useAppStore';
import { getUnacceptedContentPolicy, isEverythingSetup } from '@/utils/onboardingUtils';

const UserLayout = () => {
  return (
    <AppPageTemplate>
      <Outlet />
    </AppPageTemplate>
  );
};

export const Route = createFileRoute('/_authenticated/_user')({
  component: UserLayout,
  beforeLoad: async ({ context: { auth }, location }) => {
    const isOrgAdmin = auth?.isAdmin;
    const isSuperAdmin = auth?.isSuperAdmin;
    const isContentCreatorOnly = auth?.isContentCreator && auth?.user?.roles.length === 1;
    const isUserDashboard = location.pathname === '/user/dashboard';

    if (isContentCreatorOnly && isUserDashboard) {
      throw redirect({
        to: '/creator/profile',
      });
    }

    const { onboardingStatuses, hasUnacceptedLegalDocuments, legalAcceptanceStatuses } = useAppStore.getState();
    const pendingContentPolicy = getUnacceptedContentPolicy(legalAcceptanceStatuses);

    if (!isSuperAdmin && auth?.isContentCreator && pendingContentPolicy) {
      throw redirect({
        to: '/creator/apply/content-policy',
      });
    }

    const isOnboardingCompleted = isEverythingSetup(onboardingStatuses, isOrgAdmin, isContentCreatorOnly);

    if (!isOnboardingCompleted && !isSuperAdmin) {
      const { isOrganizationOnboardingCompleted, isUserOnboardingCompleted } = onboardingStatuses;

      if (isOrgAdmin && !isOrganizationOnboardingCompleted) {
        throw redirect({
          to: '/onboarding/organization',
        });
      }

      if (!isUserOnboardingCompleted) {
        throw redirect({
          to: '/onboarding/user',
        });
      }
    }

    if (hasUnacceptedLegalDocuments && !isSuperAdmin) {
      if (auth?.isContentCreator && pendingContentPolicy) {
        throw redirect({
          to: '/creator/apply/content-policy',
        });
      }

      throw redirect({
        to: '/eula/update',
      });
    }
  },
});
